import Swiper, { FreeMode } from 'swiper';

export default class BannerSlide {
  constructor() {
    this.init();
  }
  init() {
    var slide = new Swiper('.js-bannerSwiper', {
      modules: [FreeMode],
      // initialSlide: 0,
      slidesPerView: 'auto',
      // centeredSlides : true,
      freeMode: {
        enabled: true,
      }, 
      breakpoints: {
        768: {
          freeMode: {
            enabled: false,
          }, 
        },
      }
    });

    let editBox = document.querySelectorAll('.p-banner__list');

    for (let i = 0; i < editBox.length; i++) {
      let box = editBox[i];
      let item = box.querySelectorAll('.p-banner__item');

      if(item.length === 3) {
        box.style.justifyContent = 'inherit';
      } else {
        box.style.justifyContent = 'center';
      }
    }
  }
}